import { SocketMessageTypes } from 'Modules'
import { Callback } from 'Types/utilTypes'
import { ChatChannelHandler, ChatSocketDataPayload, chatSocketSlice } from 'Pages/chat'

export class PingChannel implements ChatChannelHandler {
	private chatPongTimeout: NodeJS.Timer
	private chatPongTimer: NodeJS.Timer
	private chatSubscribeTimer: NodeJS.Timer

	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: ChatSocketDataPayload) {
		if (data?.type === SocketMessageTypes.CONFIRM_SUBSCRIPTION) {
			clearInterval(this.chatPongTimer)
			clearTimeout(this.chatPongTimeout)
			clearTimeout(this.chatSubscribeTimer)
			this.chatPongTimer = setInterval(() => {
				this.dispatch(chatSocketSlice.actions.sendPingMessage())
				this.chatPongTimeout = setTimeout(() => {
					this.chatSubscribeTimer = setTimeout(() => {
						this.dispatch(chatSocketSlice.actions.subscribeChannels([]))
					}, 1000)
					clearInterval(this.chatPongTimer)
				}, 5000)
			}, 10000)
		}

		if (data?.message === SocketMessageTypes.PONG) {
			clearTimeout(this.chatPongTimeout)
		}
	}
}
